/**
 * @generated SignedSource<<b9bd031f7855ba7c9c6fe646a439fac1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "email"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "email",
        "variableName": "email"
      }
    ],
    "concreteType": "BasicMutationResponse",
    "kind": "LinkedField",
    "name": "sendInvitationEmail",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SendInvitationEmailMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SendInvitationEmailMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "872c8b9603af2a7e21db3b24f0195854",
    "id": null,
    "metadata": {},
    "name": "SendInvitationEmailMutation",
    "operationKind": "mutation",
    "text": "mutation SendInvitationEmailMutation(\n  $email: String!\n) {\n  sendInvitationEmail(email: $email) {\n    ok\n    error\n  }\n}\n"
  }
};
})();

node.hash = "c97f1ea7d3927d609c0599d377eb61b9";

export default node;
